module.exports = {
      id: "women-home-usage",
      viewBox: "0 0 64.575 75.722",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#women-home",
      toString: function () {
        return this.url;
      }
    }